module.exports = __webpack_public_path__ + "static/media/success.18d00d2b.png";